export default "__VITE_ASSET__50add3ab__"